
export const SET_SEARCH_PARAMETER = 'src/components/Cases/Create/action/Set_Search_Parameter';
export const setSearchParameter = (param) => {
    return {
        type: SET_SEARCH_PARAMETER,
        payload: param
    };

}

export const CLEAR_DATA = 'src/components/Cases/Create/action/Clear_Data';
export const clearData = () => {
    return {
        type: CLEAR_DATA
    };

}

export const CLEAR_RESULT = 'src/components/Cases/Create/action/Clear_Result';
export const clearResult = () => {
    return {
        type: CLEAR_RESULT
    };

}



export const SELECTED_CORPORATE = 'src/components/Cases/Create/action/Selected_Corporate';
export const selectedCorporate = (corporate) => {
    return {
        type: SELECTED_CORPORATE,
        payload: corporate
    };

}

export const SELECTED_USER = 'src/components/Cases/Create/action/Selected_User';
export const selectedUser = (user) => {
    return {
        type: SELECTED_USER,
        payload: user
    };

}

export const SELECTED_COUNTERPARTY = 'src/components/Cases/Create/action/Selected_Counterparty';
export const selectedCounterparty = (counterparty) => {
    return {
        type: SELECTED_COUNTERPARTY,
        payload: counterparty
    };

}

export const SELECTED_PRODUCT = 'src/components/Cases/Create/action/Selected_Product';
export const selectedProduct = (product) => {
    return {
        type: SELECTED_PRODUCT,
        payload: product
    };

}

export const CLEAR_COUNTERPARTY = 'src/components/Cases/Create/action/Clear_Counterparty';
export const clearCounterParty = (product) => {
    return {
        type: CLEAR_COUNTERPARTY
    };

}

export const SEARCH_CORPORATE_PARAMETER = 'src/components/Cases/Create/action/Search_Param';
export const setSearchCorporateParameter = (parameter, search) => {
    return {
        type: SEARCH_CORPORATE_PARAMETER,
        search,
        parameter
    }
}
export const SEARCH_CORPORATE_RESULTS_SUCCESS = 'src/components/Cases/Create/action/Search_Param_Success';
export const SEARCH_CORPORATE_RESULTS_FAILURE = 'src/components/Cases/Create/action/Search_Param_Failure';
export const searchCorporateResultsSuccess = (data) => {
    return {
        type: SEARCH_CORPORATE_RESULTS_SUCCESS,
        data
    }
}
export const searchCorporateResultsFailure = (error) => {
    return {
        type: SEARCH_CORPORATE_RESULTS_FAILURE,
        error
    }
}
export const SEARCH_COUNTERPARTY_PARAMETER = 'src/components/Cases/Create/action/Search_Counterparty_Param';
export const setSearchCounterpartyParameter = (parameter, search, countryCode, countryName, pageNo = 1, pageSize = 10, caseType) => {
    return {
        type: SEARCH_COUNTERPARTY_PARAMETER,
        search,
        parameter,
        countryCode,
        countryName,
        pageNo,
        pageSize,
        caseType
    }
}
export const SEARCH_COUNTERPARTY_RESULTS_SUCCESS = 'src/components/Cases/Create/action/Search_Counterparty_Param_Success';
export const SEARCH_COUNTERPARTY_RESULTS_FAILURE = 'src/components/Cases/Create/action/Search_Counterparty_Param_Failure';
export const searchCounterpartyResultsSuccess = (data) => {
    return {
        type: SEARCH_COUNTERPARTY_RESULTS_SUCCESS,
        data
    }
}
export const searchCounterpartyResultsFailure = (error) => {
    return {
        type: SEARCH_COUNTERPARTY_RESULTS_FAILURE,
        error
    }
}

export const RESET_COUNTERPARTY_PAGINATION = 'src/components/Cases/Create/action/Reset_Counterparty_Pagination';
export const resetCounterpartyPagination = () => {
    return {
        type: RESET_COUNTERPARTY_PAGINATION
    }
}

export const GET_COUNTERPARTY_TYPE = 'src/components/Cases/Create/action/Get_Counterparty_Type';
export const getCounterpartyType = () => {
    return {
        type: GET_COUNTERPARTY_TYPE
    }
}
export const GET_COUNTERPARTY_TYPE_SUCCESS = 'src/components/Cases/Create/action/Get_Counterparty_Type_Success';
export const GET_COUNTERPARTY_TYPE_FAILURE = 'src/components/Cases/Create/action/Get_Counterparty_Type_Failure';
export const getCounterpartyTypeSuccess = (data) => {
    return {
        type: GET_COUNTERPARTY_TYPE_SUCCESS,
        data
    }
}
export const getCounterpartyTypeFailure = (error) => {
    return {
        type: GET_COUNTERPARTY_TYPE_FAILURE,
        error
    }
}

export const GET_REPORT_CATEGORY_SUCCESS = 'src/components/Cases/Create/action/Get_Report_Category_Success';
export const GET_REPORT_CATEGORY_FAILURE = 'src/components/Cases/Create/action/Get_Report_Category_Failure';
export const GET_REPORT_CATEGORY = 'src/components/Cases/Create/action/Get_Report_Category';
export const getreportCategory = () => {
    return {
        type: GET_REPORT_CATEGORY
    }
}

export const getReportCategorySuccess = (data) => {
    return {
        type: GET_REPORT_CATEGORY_SUCCESS,
        data
    }
}
export const getReportCategoryFailure = (error) => {
    return {
        type: GET_REPORT_CATEGORY_FAILURE,
        error
    }
}

export const GET_REPORT_FRONT_COVER_LIST_SUCCESS = 'src/components/Cases/Create/action/Get_Report_Front_Cover_List_Success';
export const GET_REPORT_FRONT_COVER_LIST_FAILURE = 'src/components/Cases/Create/action/Get_Report_Front_Cover_List_Failure';
export const GET_REPORT_FRONT_COVER_LIST = 'src/components/Cases/Create/action/Get_Report_Front_Cover_List';
export const getReportFrontCoverList = () => {
    return {
        type: GET_REPORT_FRONT_COVER_LIST
    }
}

export const getReportFrontCoverListSuccess = (data) => {
    return {
        type: GET_REPORT_FRONT_COVER_LIST_SUCCESS,
        data
    }
}
export const getReportFrontCoverListFailure = (error) => {
    return {
        type: GET_REPORT_FRONT_COVER_LIST_FAILURE,
        error
    }
}


export const GET_PORTFOLIO_COUNT_SUCCESS = 'src/components/Cases/Create/action/Get_Portfolio_Count_Success';
export const GET_PORTFOLIO_COUNT_FAILURE = 'src/components/Cases/Create/action/Get_Portfolio_Count_Failure';
export const GET_PORTFOLIO_COUNT = 'src/components/Cases/Create/action/Get_Portfolio_Count';
export const getPortfolioCount = () => {
    return {
        type: GET_PORTFOLIO_COUNT
    }
}

export const getPortfolioCountSuccess = (data) => {
    return {
        type: GET_PORTFOLIO_COUNT_SUCCESS,
        data
    }
}
export const getPortfolioCountFailure = (error) => {
    return {
        type: GET_PORTFOLIO_COUNT_FAILURE,
        error
    }
}

export const GET_PRODUCTS = 'src/components/Cases/Create/action/Get_Product';
export const getProducts = (id, search,selectedProductCategory,reportCategory) => {
    return {
        type: GET_PRODUCTS,
        id,
        search,
        selectedProductCategory,
        reportCategory
    }
}
export const GET_PRODUCTS_SUCCESS = 'src/components/Cases/Create/action/Get_Product_Success';
export const GET_PRODUCTS_FAILURE = 'src/components/Cases/Create/action/Get_Product_Failure';
export const getProductsSuccess = (data) => {
    return {
        type: GET_PRODUCTS_SUCCESS,
        data
    }
}
export const getProductsFailure = (error) => {
    return {
        type: GET_PRODUCTS_FAILURE,
        error
    }
}

export const GET_ALLDIVISIONSUBSIDIARY = 'src/components/Cases/Create/action/Get_AllDivisionSubsidiary';
export const getAllDivisionSubsidiary = (id) => {
    return {
        type: GET_ALLDIVISIONSUBSIDIARY,
        id
    }
}
export const GET_ALLDIVISIONSUBSIDIARY_SUCCESS = 'src/components/Cases/Create/action/Get_AllDivisionSubsidiary_Success';
export const GET_ALLDIVISIONSUBSIDIARY_FAILURE = 'src/components/Cases/Create/action/Get_AllDivisionSubsidiary_Failure';
export const getAllDivisionSubsidiarySuccess = (data) => {
    return {
        type: GET_ALLDIVISIONSUBSIDIARY_SUCCESS,
        data
    }
}
export const getAllDivisionSubsidiaryFailure = (error) => {
    return {
        type: GET_ALLDIVISIONSUBSIDIARY_FAILURE,
        error
    }
}

export const GET_USERS = 'src/components/Cases/Create/action/Get_Users';
export const GET_USERS_SUCCESS = 'src/components/Cases/Create/action/Get_Users_Success';
export const GET_USERS_FAILURE = 'src/components/Cases/Create/action/Get_Users_Failure';

export const getUsers = (id, search) => {
    return {
        type: GET_USERS,
        id,
        search
    }
}
export const getUsersSuccess = (data) => {
    return {
        type: GET_USERS_SUCCESS,
        data
    }
}
export const getUsersFailure = (error) => {
    return {
        type: GET_USERS_FAILURE,
        error
    }
}


export const CREATE_CASE = 'src/components/Cases/Create/action/Create_case';
export const createCase = (data) => {
    return {
        type: CREATE_CASE,
        data
    }
}
export const CREATE_CASE_SUCCESS = 'src/components/Cases/Create/action/Create_Case_Success';
export const CREATE_CASE_FAILURE = 'src/components/Cases/Create/action/Create_Case_Failure';
export const createCaseSuccess = (data) => {
    return {
        type: CREATE_CASE_SUCCESS,
        data
    }
}
export const createCaseFailure = (error) => {
    return {
        type: CREATE_CASE_FAILURE,
        error
    }
}

export const CREATE_SUBSCRIPTION_DATABASE_CASE = 'src/components/Cases/Create/action/Create_Subscription_Database_case';
export const createSubscriptionDatabaseCase = (data) => {
    return {
        type: CREATE_SUBSCRIPTION_DATABASE_CASE,
        data
    }
}
export const CREATE_SUBSCRIPTION_DATABASE_CASE_SUCCESS = 'src/components/Cases/Create/action/Create_Subscription_Database_Case_Success';
export const CREATE_SUBSCRIPTION_DATABASE_CASE_FAILURE = 'src/components/Cases/Create/action/Create_Subscription_Database_Case_Failure';
export const createSubscriptionDatabaseCaseSuccess = (data) => {
    return {
        type: CREATE_SUBSCRIPTION_DATABASE_CASE_SUCCESS,
        data
    }
}
export const createSubscriptionDatabaseCaseSFailure = (error) => {
    return {
        type: CREATE_SUBSCRIPTION_DATABASE_CASE_FAILURE,
        error
    }
}

export const CREATE_COUNTERPARTY = 'src/components/Cases/Create/action/Create_Counterparty';
export const createCounterparty = (data) => {
    return {
        type: CREATE_COUNTERPARTY,
        data
    }
}
export const CREATE_COUNTERPARTY_SUCCESS = 'src/components/Cases/Create/action/Create_Counterparty_Success';
export const CREATE_COUNTERPARTY_FAILURE = 'src/components/Cases/Create/action/Create_Counterparty_Failure';
export const createCounterpartySuccess = (data) => {
    return {
        type: CREATE_COUNTERPARTY_SUCCESS,
        data
    }
}
export const createCounterpartyFailure = (error) => {
    return {
        type: CREATE_COUNTERPARTY_FAILURE,
        error
    }
}

export const GET_ZONE_FOR_STATE = 'src/components/Cases/Create/action/Get_Zone_For_State';
export const GET_ZONE_FOR_STATE_SUCCESS = 'src/components/Cases/Create/action/Get_Zone_For_State_Success';
export const GET_ZONE_FOR_STATE_FAILURE = 'src/components/Cases/Create/action/Get_Zone_For_State_Failure';
export const getZoneForState = (data) => {
    return {
        type: GET_ZONE_FOR_STATE,
        data
    }
}

export const getZoneForStateSuccess = (data) => {
    return {
        type: GET_ZONE_FOR_STATE_SUCCESS,
        data
    }
}
export const getZoneForStateFailure = (error) => {
    return {
        type: GET_ZONE_FOR_STATE_FAILURE,
        error
    }
}
export const GET_ZONE = 'src/components/Cases/Create/action/Get_Zone';
export const GET_ZONE_SUCCESS = 'src/components/Cases/Create/action/Get_Zone_Success';
export const GET_ZONE_FAILURE = 'src/components/Cases/Create/action/Get_Zone_Failure';
export const getZone = () => {
    return {
        type: GET_ZONE
    }
}

export const getZoneSuccess = (data) => {
    return {
        type: GET_ZONE_SUCCESS,
        data
    }
}
export const getZoneFailure = (error) => {
    return {
        type: GET_ZONE_FAILURE,
        error
    }
}

export const GET_INDIANSTATES = 'src/components/Cases/Create/action/Get_IndianStates';
export const GET_INDIANSTATES_SUCCESS = 'src/components/Cases/Create/action/Get_IndianStates_Success';
export const GET_INDIANSTATES_FAILURE = 'src/components/Cases/Create/action/Get_IndianStates_Failure';
export const getIndianStates = () => {
    return {
        type: GET_INDIANSTATES
    }
}

export const getIndianStatesSuccess = (data) => {
    return {
        type: GET_INDIANSTATES_SUCCESS,
        data
    }
}
export const getIndianStatesFailure = (error) => {
    return {
        type: GET_INDIANSTATES_FAILURE,
        error
    }
}

export const CREATE_BULK_BUY = 'src/components/Cases/Create/action/Create_Bulk_Buy';
export const createBulkBuy = (data) => {
    return {
        type: CREATE_BULK_BUY,
        data
    }
}

